module.exports = __webpack_public_path__ + "static/media/edit-payment-icon.1512b14b.svg";